import { Component, Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { OrderList } from '../../../order/components/order-list/component';
import { IOrderListConfig } from '../../../order/interfaces/order-list-config';
import { IEvent } from '../../interfaces/event';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'event-guest-list-dialog',
    templateUrl: 'component.html',
    styleUrls: [
        '../../../order/components/order-list/component.scss',
        'component.scss',
    ],
    standalone: false
})
@Injectable()
export class EventOrderList extends OrderList {
  public Item: IEvent;
  protected colunms = [
    {
      name: 'name',
      displayName: 'Name',
      width: '*',
    },
    {
      name: 'employee_number',
      displayName: 'Employee Number',
      width: 'auto',
    },
    {
      name: 'phone',
      displayName: 'Phone',
      width: 'auto',
    },
    {
      name: 'total_tickets',
      displayName: 'Total Tickets',
      width: 'auto',
    },
    {
      name: 'cohort',
      displayName: 'Cohort',
      width: 'auto',
    },
  ];
  public displayedColumns = [
    'status',
    'name',
    'email',
    'branch_employee_number',
    'total_tickets',
    'purchase_date',
    'notes',
    'actions',
  ];

  protected getFileName(): string {
    const { event_title, location_title, start_date } = this.Item;

    return `${event_title}-${location_title}-${start_date}`;
  }

  protected getColumns() {
    const isSuperAdmin = this.Auth.inGroup('superadmin');
    return isSuperAdmin
      ? this.colunms
      : [this.colunms[0], this.colunms[1], this.colunms[3], this.colunms[4]];
  }

  public constructor(
    protected Dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) protected config: IOrderListConfig,
    Auth: AuthService
  ) {
    super(Auth);

    this.DataSource = config.DataSource;
    this.Item = config.Item as IEvent;
    this.title = config.title;
  }
}
